import { render, staticRenderFns } from "./paperList.vue?vue&type=template&id=17098f6e&scoped=true"
import script from "./paperList.vue?vue&type=script&lang=js"
export * from "./paperList.vue?vue&type=script&lang=js"
import style0 from "./paperList.vue?vue&type=style&index=0&id=17098f6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17098f6e",
  null
  
)

export default component.exports